//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./connector.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// struct GoogleDriveInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `GoogleDriveInfo.Mutable`. */
export class GoogleDriveInfo extends $._FrozenBase {}

function initGoogleDriveInfo(target, initializer) {
  target.token = initializer.token ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.tokenExpiry = initializer.tokenExpiry ?? $.Timestamp.UNIX_EPOCH;
  target.rootFolderIds = $._toFrozenArray(
    initializer.rootFolderIds || []);
    target.authenticatedUserEmail = initializer.authenticatedUserEmail ?? "";
}

// -----------------------------------------------------------------------------
// struct ConfluenceInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ConfluenceInfo.Mutable`. */
export class ConfluenceInfo extends $._FrozenBase {}

function initConfluenceInfo(target, initializer) {
  target.token = initializer.token ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.tokenExpiry = initializer.tokenExpiry ?? $.Timestamp.UNIX_EPOCH;
  target.rootFolderIds = $._toFrozenArray(
    initializer.rootFolderIds || []);
}

// -----------------------------------------------------------------------------
// struct NotionInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `NotionInfo.Mutable`. */
export class NotionInfo extends $._FrozenBase {}

function initNotionInfo(target, initializer) {
  target.token = initializer.token ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.botId = initializer.botId ?? "";
  target.workspaceId = initializer.workspaceId ?? "";
  target.workspaceName = initializer.workspaceName ?? "";
}

// -----------------------------------------------------------------------------
// struct SlackInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SlackInfo.Mutable`. */
export class SlackInfo extends $._FrozenBase {}

function initSlackInfo(target, initializer) {
  target.token = initializer.token ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.tokenExpiry = initializer.tokenExpiry ?? $.Timestamp.UNIX_EPOCH;
  target.channels = $._toFrozenArray(
    initializer.channels || []);
}

// -----------------------------------------------------------------------------
// struct WebCrawlerSource
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `WebCrawlerSource.Mutable`. */
export class WebCrawlerSource extends $._FrozenBase {}

function initWebCrawlerSource(target, initializer) {
  target.url = initializer.url ?? "";
  target.name = initializer.name ?? "";
  target.refreshInterval = initializer.refreshInterval ?? 0;
  target.maxPages = initializer.maxPages ?? 0;
  target.maxDepth = initializer.maxDepth ?? 0;
}

// -----------------------------------------------------------------------------
// struct WebCrawlerInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `WebCrawlerInfo.Mutable`. */
export class WebCrawlerInfo extends $._FrozenBase {}

function initWebCrawlerInfo(target, initializer) {
  target.userAgent = initializer.userAgent ?? "";
  target.crawlDelay = initializer.crawlDelay ?? 0;
  target.sources = $._toFrozenArray(
    initializer.sources || [],
    WebCrawlerSource.create,
  );
}

// -----------------------------------------------------------------------------
// struct CallTranscriptsInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CallTranscriptsInfo.Mutable`. */
export class CallTranscriptsInfo extends $._FrozenBase {}

function initCallTranscriptsInfo(target, initializer) {}

// -----------------------------------------------------------------------------
// struct CuratedQaInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CuratedQaInfo.Mutable`. */
export class CuratedQaInfo extends $._FrozenBase {}

function initCuratedQaInfo(target, initializer) {}

// -----------------------------------------------------------------------------
// struct DustDataSourceRef
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `DustDataSourceRef.Mutable`. */
export class DustDataSourceRef extends $._FrozenBase {}

function initDustDataSourceRef(target, initializer) {
  target.spaceId = initializer.spaceId ?? "";
  target.spaceName = initializer.spaceName ?? "";
  target.dataSourceId = initializer.dataSourceId ?? "";
  target.dataSourceName = initializer.dataSourceName ?? "";
}

// -----------------------------------------------------------------------------
// struct DustInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `DustInfo.Mutable`. */
export class DustInfo extends $._FrozenBase {}

function initDustInfo(target, initializer) {
  target.apiToken = initializer.apiToken ?? "";
  target.workspaceId = initializer.workspaceId ?? "";
  target.dataSources = $._toFrozenArray(
    initializer.dataSources || [],
    DustDataSourceRef.create,
  );
}

// -----------------------------------------------------------------------------
// enum Connector.Source
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias Connector.Source
 */
class Connector_Source extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum Connector.ConnectionInfo
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias Connector.ConnectionInfo
 */
class Connector_ConnectionInfo extends $._EnumBase {}

function createValueOfConnector_ConnectionInfo(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "google_drive": {
      return GoogleDriveInfo.create(value);
    }
    case "confluence": {
      return ConfluenceInfo.create(value);
    }
    case "notion": {
      return NotionInfo.create(value);
    }
    case "slack": {
      return SlackInfo.create(value);
    }
    case "web_crawler": {
      return WebCrawlerInfo.create(value);
    }
    case "call_transcripts": {
      return CallTranscriptsInfo.create(value);
    }
    case "dust": {
      return DustInfo.create(value);
    }
    case "curated_qa": {
      return CuratedQaInfo.create(value);
    }
  }
}

// -----------------------------------------------------------------------------
// struct Connector
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `Connector.Mutable`. */
export class Connector extends $._FrozenBase {}

function initConnector(target, initializer) {
  target.id = initializer.id ?? 0;
  target.spaceId = initializer.spaceId ?? 0;
  target.source = Connector_Source.create(initializer.source ?? Connector_Source.UNKNOWN);
  target.connectionInfo = Connector_ConnectionInfo.create(initializer.connectionInfo ?? Connector_ConnectionInfo.UNKNOWN);
  target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
  target.updatedAt = initializer.updatedAt ?? $.Timestamp.UNIX_EPOCH;
  target.accountId = initializer.accountId ?? 0;
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "connector.skir",
  [
    {
      kind: "struct",
      ctor: GoogleDriveInfo,
      initFn: initGoogleDriveInfo,
      name: "GoogleDriveInfo",
      fields: [
        {
          name: "token",
          property: "token",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "token_expiry",
          property: "tokenExpiry",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "root_folder_ids",
          property: "rootFolderIds",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableRootFolderIds",
        },
        {
          name: "authenticated_user_email",
          property: "authenticatedUserEmail",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ConfluenceInfo,
      initFn: initConfluenceInfo,
      name: "ConfluenceInfo",
      fields: [
        {
          name: "token",
          property: "token",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "token_expiry",
          property: "tokenExpiry",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "root_folder_ids",
          property: "rootFolderIds",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableRootFolderIds",
        },
      ],
    },
    {
      kind: "struct",
      ctor: NotionInfo,
      initFn: initNotionInfo,
      name: "NotionInfo",
      fields: [
        {
          name: "token",
          property: "token",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "bot_id",
          property: "botId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "workspace_id",
          property: "workspaceId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "workspace_name",
          property: "workspaceName",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: SlackInfo,
      initFn: initSlackInfo,
      name: "SlackInfo",
      fields: [
        {
          name: "token",
          property: "token",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "token_expiry",
          property: "tokenExpiry",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "channels",
          property: "channels",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableChannels",
        },
      ],
    },
    {
      kind: "struct",
      ctor: WebCrawlerSource,
      initFn: initWebCrawlerSource,
      name: "WebCrawlerSource",
      fields: [
        {
          name: "url",
          property: "url",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_interval",
          property: "refreshInterval",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "max_pages",
          property: "maxPages",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "max_depth",
          property: "maxDepth",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: WebCrawlerInfo,
      initFn: initWebCrawlerInfo,
      name: "WebCrawlerInfo",
      fields: [
        {
          name: "user_agent",
          property: "userAgent",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crawl_delay",
          property: "crawlDelay",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "sources",
          property: "sources",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: WebCrawlerSource,
            },
          },
          mutableGetter: "mutableSources",
        },
      ],
    },
    {
      kind: "struct",
      ctor: CallTranscriptsInfo,
      initFn: initCallTranscriptsInfo,
      name: "CallTranscriptsInfo",
      fields: [],
    },
    {
      kind: "struct",
      ctor: CuratedQaInfo,
      initFn: initCuratedQaInfo,
      name: "CuratedQaInfo",
      fields: [],
    },
    {
      kind: "struct",
      ctor: DustDataSourceRef,
      initFn: initDustDataSourceRef,
      name: "DustDataSourceRef",
      fields: [
        {
          name: "space_id",
          property: "spaceId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "space_name",
          property: "spaceName",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "data_source_id",
          property: "dataSourceId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "data_source_name",
          property: "dataSourceName",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: DustInfo,
      initFn: initDustInfo,
      name: "DustInfo",
      fields: [
        {
          name: "api_token",
          property: "apiToken",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "workspace_id",
          property: "workspaceId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "data_sources",
          property: "dataSources",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: DustDataSourceRef,
            },
          },
          mutableGetter: "mutableDataSources",
        },
      ],
    },
    {
      kind: "enum",
      ctor: Connector_Source,
      name: "Source",
      parentCtor: Connector,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "LOCAL_FILESYSTEM",
          number: 1,
        },
        {
          name: "GOOGLE_DRIVE",
          number: 2,
        },
        {
          name: "CONFLUENCE",
          number: 3,
        },
        {
          name: "NOTION",
          number: 4,
        },
        {
          name: "SLACK",
          number: 5,
        },
        {
          name: "WEB_CRAWLER",
          number: 6,
        },
        {
          name: "CALL_TRANSCRIPTS",
          number: 7,
        },
        {
          name: "DUST",
          number: 8,
        },
        {
          name: "CURATED_QA",
          number: 9,
        },
      ],
    },
    {
      kind: "enum",
      ctor: Connector_ConnectionInfo,
      createValueFn: createValueOfConnector_ConnectionInfo,
      name: "ConnectionInfo",
      parentCtor: Connector,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "LOCAL",
          number: 1,
        },
        {
          name: "google_drive",
          number: 2,
          type: {
            kind: "record",
            ctor: GoogleDriveInfo,
          },
        },
        {
          name: "confluence",
          number: 3,
          type: {
            kind: "record",
            ctor: ConfluenceInfo,
          },
        },
        {
          name: "notion",
          number: 4,
          type: {
            kind: "record",
            ctor: NotionInfo,
          },
        },
        {
          name: "slack",
          number: 5,
          type: {
            kind: "record",
            ctor: SlackInfo,
          },
        },
        {
          name: "web_crawler",
          number: 6,
          type: {
            kind: "record",
            ctor: WebCrawlerInfo,
          },
        },
        {
          name: "call_transcripts",
          number: 7,
          type: {
            kind: "record",
            ctor: CallTranscriptsInfo,
          },
        },
        {
          name: "dust",
          number: 8,
          type: {
            kind: "record",
            ctor: DustInfo,
          },
        },
        {
          name: "curated_qa",
          number: 9,
          type: {
            kind: "record",
            ctor: CuratedQaInfo,
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: Connector,
      initFn: initConnector,
      name: "Connector",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "space_id",
          property: "spaceId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "source",
          property: "source",
          number: 2,
          type: {
            kind: "record",
            ctor: Connector_Source,
          },
        },
        {
          name: "connection_info",
          property: "connectionInfo",
          number: 3,
          type: {
            kind: "record",
            ctor: Connector_ConnectionInfo,
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "updated_at",
          property: "updatedAt",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
  ]
);
